import React from "react";
import Autocomplete from "../../elements/Select/Autocomplete";
import {JOB_REGION} from "../../utils/constant";

const RegionDropDown = ({selectedData = "", handleChange}) => {
    return (
        <Autocomplete
            data={JOB_REGION}
            displayLabel={"label"}
            selectedData={selectedData || ""}
            equalKey={"value"}
            minWidth={"auto"}
            onChange={handleChange}
            inputProps={{
                type: "text",
                title: "Region (Remote)",
                variant: "outlined",
                placeholder: "Region (Remote)",
                autoFocus: true,
                noMargin: true,
                InputProps: {
                    style: {minHeight: 45}
                },
                InputLabelProps: {
                    shrink: false,
                },
                size: "small"
            }}
        />
    )
}

export default RegionDropDown;
